var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcb49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc1d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc162c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4985d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d77c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ba343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408d39"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.047619h-16z",
    fill: "url(#c)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 5.333333h16v3.047619h-16z",
    fill: "url(#d)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 8.380952h16v3.047619h-16z",
    fill: "url(#e)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.047619h16v2.285714h-16z",
    fill: "url(#a)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 11.4285714 7.61904762-5.71428569-7.61904762-5.71428571z",
    fill: "url(#f)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.61904762 3.50058142c-.18263996-.04700828-.37411453-.07200999-.57142857-.07200999-1.26236515 0-2.28571429 1.02334914-2.28571429 2.28571428 0 1.26236515 1.02334914 2.28571429 2.28571429 2.28571429.19731404 0 .38878861-.02500175.57142857-.07200998-.98584412-.25373874-1.71428572-1.1486532-1.71428572-2.21370431 0-1.0650511.7284416-1.95996555 1.71428572-2.21370429zm.57142857 1.07084715c-.21039419 0-.38095238-.17055819-.38095238-.38095238s.17055819-.38095238.38095238-.38095238.38095238.17055819.38095238.38095238-.17055819.38095238-.38095238.38095238zm0 1.52380953c-.21039419 0-.38095238-.1705582-.38095238-.38095239 0-.21039418.17055819-.38095238.38095238-.38095238s.38095238.1705582.38095238.38095238c0 .21039419-.17055819.38095239-.38095238.38095239zm0 1.52380952c-.21039419 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055819-.38095238.38095238-.38095238s.38095238.17055819.38095238.38095238c0 .21039418-.17055819.38095238-.38095238.38095238z",
    fill: "url(#a)",
    mask: "url(#g)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/KM.0ae8ce5e18c7d5576db581dc90712f9f.svg";
export { ForwardRef as ReactComponent };